<template>
  <v-dialog v-model="dOpenComponente" persistent width="800px" content-class="">
    <v-card>
      <!-- cabecera del dialogo -->

      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{ dInformeComponente.nombre }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-dialog v-model="dLoading" hide-overlay persistent width="300">
        <v-card class="datModalTitleContainer" dark>
          <v-card-text>
            {{ $t('cargandoContenido') }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-flex xs12 class="pl-2 datModalSubtitle mb-3">
            {{ dInformeComponente.descripcion }}
          </v-flex>
          <!-- representantes -->
          <v-layout row wrap>

            <v-flex xs12 sm6 md2 px-2>
              <v-select :items="dYears" :label="$t('ejercicio')" v-model="dSelectedYear" />
            </v-flex>
            <v-flex xs12 sm6 md3 px-2>
              <v-autocomplete :items="dCountries" :label="$t('country')" v-model="dSelectedCountry" item-value="pais"
                clearable item-text="nombrePais" :disabled="!dCountriesLoaded" @change="fLoadProvinces()" />
            </v-flex>
            <v-flex xs12 sm6 md3 px-2>
              <v-autocomplete :items="dProvinces" :label="$t('Province') + ' ' + $t('initial')"
                v-model="dSelectedIniProv" clearable item-value="id" item-text="denominacion"
                :disabled="!dProvincesLoaded" />
            </v-flex>
            <v-flex xs12 sm6 md4 px-2>
              <v-autocomplete :items="dProvinces" :label="$t('Province') + ' ' + $t('final')"
                v-model="dSelectedFinProv" clearable item-value="id" item-text="denominacion"
                :disabled="!dProvincesLoaded" />
            </v-flex>
            <v-flex v-if="dRole !== 'CLIENTE'" xs12 sm12 px-2>
              <DatTextFieldCodeSubfield ref="TablaRepresentante" :pDataPass="dDataRepre" @alert="fAlert"
                @select="fSelectRepre" @clean="fCleanRepre"></DatTextFieldCodeSubfield>
            </v-flex>

            <v-flex xs12 sm6 md4 px-2>
              <v-select :items="dOrderStatus" :label="$t('OrderStatus')" v-model="dSelectedStatus" item-value="id"
                item-text="description" />
            </v-flex>
            <v-flex xs12 md8 px-2>
              <v-select :items="dReportOrder" :label="$t('orden')" v-model="dSelectedOrder" item-value="id"
                item-text="description" />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="py-3 transparent">
          <v-flex xs12 pr-3 class="text-xs-right">
            <v-btn class="datPrimaryBtnOut" flat @click="fLimpiaFiltros()">{{ $t('limpiar') }}</v-btn>
            <v-btn class="datPrimaryBtn" flat @click="fDescargarInforme()" :disabled="dDisableDescarga">
              {{ dDescargarTxt }}
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>

import ServiceEntidadesPostales from '@/services/srv-entidades-postales'
import SrvImpresion from '@/services/srv-impresion'
import { generarPdf, abrirPestanaEnBlanco, abrirPdfEnPestanaPreabierta } from '@/utils/utilDescargarPdf'
import DatTextFieldCodeSubfield from '@/components_datadec/DatTextFieldCodeSubfield'

export default {
  name: 'ShpFiltroBaseInformes',
  components: {
    DatTextFieldCodeSubfield
  },
  props: {
    pInformeComponente: {
      type: Object,
      required: true
    },
    pLimitDate: {
      type: Object,
      required: false,
      default: {}
    }
  },
  data() {
    return {
      dLoading: false,
      dStringAviso: 'evento-mostrarAvisos',
      dOrderStatus: [
        { id: 1, description: this.$t('Entered') },
        { id: 2, description: this.$t('Served') },
        { id: 3, description: this.$t('Invoiced') },
        { id: 4, description: this.$t('Detained') },
        { id: 5, description: this.$t('Cancelled') }
      ],
      dReportOrder: [
        { id: 1, description: this.$t('country') + '/' + this.$t('codigo') + ' ' + this.$t('province') + '/' + this.$t('codigo') + ' ' + this.$t('representante') },
        { id: 2, description: this.$t('country') + '/' + this.$t('codigo') + ' ' + this.$t('province') + '/' + this.$t('nombre') + ' ' + this.$t('representante') },
        { id: 3, description: this.$t('country') + '/' + this.$t('codigo') + ' ' + this.$t('province') + '/' + this.$t('importe') },
        { id: 4, description: this.$t('country') + '/' + this.$t('nombre') + ' ' + this.$t('province') + '/' + this.$t('codigo') + ' ' + this.$t('representante') },
        { id: 5, description: this.$t('country') + '/' + this.$t('nombre') + ' ' + this.$t('province') + '/' + this.$t('nombre') + ' ' + this.$t('representante') },
        { id: 6, description: this.$t('country') + '/' + this.$t('nombre') + ' ' + this.$t('province') + '/' + this.$t('importe') }
      ],
      dCountriesLoaded: false,
      dProvincesLoaded: false,
      dYears: [],
      dCountries: [],
      dProvinces: [],
      dSelectedCountry: null,
      dSelectedYear: null,
      dSelectedIniProv: null,
      dSelectedFinProv: null,
      dRowsPerPage: 5,
      dSelectedStatus: 1,
      dSelectedOrder: 1,
      dDescargarTxt: this.$t('descargar'),
      dDisableDescarga: false,
      dRole: '',
      dOpenComponente: true,
      dInformeComponente: null,
      dSelectRepre: { codigo: '', subfield: '', nombre: '' },
      dRequestRepre: { empresa: this.$store.getters.getAutenticacion.empresa, pasivo: 'N' },
      dRequestRepreSec: {}
    }
  },

  created() {
    // Inicializa las variables locales
    this.dInformeComponente = this.pInformeComponente
    this.dSelectedYear = this.fCalculateYears()
    this.fLoadCountries()
    this.fIniciarVariables()
  },
  methods: {
    fLoadCountries() {
      ServiceEntidadesPostales.getCountries().then((response) => {
        this.dCountries = response
        this.dCountriesLoaded = true
      })
    },
    fIniciarVariables() {
      let isRepre = false
      this.dRole = this.pLimitDate.roleUser
      this.fAssignedRole()
      if (this.dRole === 'REPRESENTANTE') {
        isRepre = true
        this.dRequestRepreSec = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          representante: this.$store.getters.getAutenticacion.representante,
          agente: this.$store.getters.getAutenticacion.agente
        }
      }
      this.dDataRepre = {
        'errorMessages': [],
        'labelMainField': 'Representante',
        'labelSubField': 'agente',
        'label': 'representanteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'representante' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'agente' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovRep',
        'headersSec': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'REP_REPRESENTANTE' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'REP_AGENTE' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'REP_NOMBRE' }
        ],
        'filtersSec': { 'codigo': 'REP_REPRESENTANTE', 'subfield': 'REP_AGENTE', 'nombre': 'REP_NOMBRE' },
        'defaultSec': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'isSec': isRepre,
        'urlSec': 'getRepres',
        'requestSec': this.dRequestRepreSec,
        'orderByDefaultSec': 'REP_REPRESENTANTE',
        'item': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'request': this.dRequestRepre,
        'filters': { 'codigo': 'representante', 'subfield': 'agente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'default': this.dSelectRepre,
        'disabled': false,
        'required': false,
        'title': 'selectRepresentante',
        'isVisibleLoad': true,
        'orderByDefault': 'representante',
        'orderDefault': 'ASC'
      }
    },
    fSelectRepre(item) {
      if (item && item != null) {
        this.dSelectRepre.codigo = item.codigo
        this.dSelectRepre.subfield = item.subfield
        this.dSelectRepre.nombre = item.nombre
      }
    },
    fCleanRepre(item) {
      this.dSelectRepre = {}
    },
    fAssignedRole() {
      switch (this.dRole) {
        case 'CLIENTE':
          this.dSelectClient.codigo = this.$store.getters.getAutenticacion.cliente
          break
        case 'REPRESENTANTE':
          this.dSelectRepre.codigo = this.$store.getters.getAutenticacion.representante
          this.dSelectRepre.nombre = this.$store.getters.getAutenticacion.representanteNombre
          this.dSelectRepre.subfield = this.$store.getters.getAutenticacion.agente
          break
        default:
      }
    },
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    fLoadProvinces() {
      this.dProvincesLoaded = false
      ServiceEntidadesPostales.getCountryProvinces(this.dSelectedCountry).then((response) => {
        if (Array.isArray(response)) {
          this.dSelectedIniProv = null
          this.dSelectedFinProv = null
          this.dProvinces = response
          this.dProvincesLoaded = true
        } else {
          this.dSelectedIniProv = 0
          this.dSelectedFinProv = 9999999
          this.dProvinces = []
        }
      })
    },
    fCalculateYears() {
      const actYear = new Date().getFullYear()

      for (let i = 0; i < 20; i++) {
        this.dYears.push(actYear - i)
      }
      return actYear
    },
    /**
     * Metodo para cerrar la ventana
     */
    fCerrarVentana() {
      this.fLimpiaFiltros()
      this.$emit('closed')
    },
    /**
     * Metodo de limpieza de los filtros
     */
    fLimpiaFiltros() {
      if (this.dRole === 'ADMIN') {
        this.dSelectRepre = { codigo: '', subfield: '', nombre: '' }
        if (this.$refs.TablaRepresentante) {
          this.$refs.TablaRepresentante.fActualizarItem(this.dSelectRepre)
        }
      }
      this.dSelectedCountry = null
      this.dSelectedOrder = 1
      this.dSelectedStatus = 1
      this.dSelectedIniProv = null
      this.dSelectedFinProv = null
      this.dSelectedYear = new Date().getFullYear()
    },
    /**
     * Metodo de descarga del informes
     */
    fAssignedFilters(jsonEntrada) {
      if (((this.dSelectRepre !== undefined) && (this.dSelectRepre.codigo !== '') && (this.dSelectRepre.codigo !== undefined))) {
        jsonEntrada.repIni = String(this.dSelectRepre.codigo)
        jsonEntrada.repFin = String(this.dSelectRepre.codigo)
      }
      jsonEntrada.ejercicio = (this.dSelectedYear !== undefined) ? this.dSelectedYear : ''
      jsonEntrada.pedido = (this.dSelectedStatus.toString() !== undefined) ? this.dSelectedStatus.toString() : ''
      jsonEntrada.orden = (this.dSelectedOrder.toString() !== undefined) ? this.dSelectedOrder.toString() : ''
      if (this.dSelectedCountry !== undefined) {
        jsonEntrada.paisIni = this.dSelectedCountry
        jsonEntrada.paisFin = this.dSelectedCountry
      }
      jsonEntrada.provinciaIni = (this.dSelectedIniProv !== undefined) ? this.dSelectedIniProv : ''
      jsonEntrada.provinciaFin = (this.dSelectedFinProv !== undefined) ? this.dSelectedFinProv : ''
    },
    fDescargarInforme() {
      const ventanaPdf = abrirPestanaEnBlanco()
      this.dDescargarTxt = this.$t('descargar')
      this.dDisableDescarga = true
      this.dLoading = true

      if (this.fCheckFiltrosPendientes()) {
        this.fDescargandoInforme()
        // prepara los parametros generales de busqueda
        const jsonEntrada = {
          tira: this.$store.getters.getAutenticacion.tira,
          empresa: this.$store.getters.getAutenticacion.empresa,
          tipoEmpresa: '0',
          pdfSn: 'S'
        }
        this.fAssignedFilters(jsonEntrada)

        SrvImpresion.estadisticaProvinciaRpte(jsonEntrada).then(response => {
          if (response.data.statusCode === '200') {
            if ((response.data.errorMsg === undefined || response.data.errorMsg === '') && response.data.report !== '') {
              abrirPdfEnPestanaPreabierta(generarPdf(response.data.report), ventanaPdf)
            } else {
              if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
              this.$emit('alert', '<b>' + this.$t('estadoVentaNotFound') + '</b><br> ' + this.$t('estadoVentaNotFoundDesc'))
            }
          } else {
            if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
            this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
          }
          this.dDisableDescarga = false
          this.dLoading = false
          this.dDescargarTxt = this.$t('descargar')
        }).catch(error => {
          if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
          this.fErrorComprobado(error.response)
          this.dDisableDescarga = false
          this.dLoading = false
          this.dDescargarTxt = this.$t('descargar')
        })
      } else {
        if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
        this.dDisableDescarga = false
        this.dLoading = false
        this.dDescargarTxt = this.$t('descargar')
        this.$emit('alert', '<b>' + this.$t('avisoFactura') + '</b><br/>' + this.$t('avisoFacturaDesc'))
      }
    },
    /*
     * Metodo de descargando
     */
    fDescargandoInforme() {
      this.dDisableDescarga = true
      this.dDescargarTxt = this.$t('enPreparacion')
    },
    /**
     * comprueba si falta recibir información de algun filtro
     */
    fCheckFiltrosPendientes() {
      return ((this.dSelectRepre !== undefined) && (this.dSelectRepre.codigo !== '') && (this.dSelectRepre.codigo !== undefined))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.buttonBar .card__title {
  padding: 8px !important;
}

.buttonBarSearch .card__title {
  padding: 0px !important;
}

.buttonBarSearchTop .card__text {
  padding-top: 4px !important;
  padding-bottom: -10px !important;
}

.numberInputSpinnerInput .vnis__input {
  background: #ffffff !important;
  border: 0px !important;
  border-bottom: 1px solid #999999 !important;
}

.numberInputSpinnerButton .vnis__button {
  background: #ffffff !important;
  color: #000000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Informes/Estadisticas/ShpEstadisticasProvRepre.vue